'use client';

import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { type ReactNode } from 'react';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { MdrtLogo } from '@shared/ui-components/svgs';
import { HOMEPAGE_PATH } from '../../../../utils/constants/local-paths';
import { type LanguagesContent } from '../../../../utils/hooks/get-languages-content-cached';
import { type NavigationItem } from '../../../../utils/types/navigation-items';
import { Button } from '../../../button/button';
import { useGlobalCmsContentContext } from '../../../providers/global-cms-context';
import { useUserContext } from '../../../providers/user-context';
import { type HeaderAccountDropdownContent } from '../../graphql/get-header-profile-dropdown-content';
import { ModalTrigger } from '../navigation-mobile/modal-trigger';
import { Navigation } from '../navigation/navigation';
import { NotificationsModalTrigger } from '../notifications/notifications-modal-trigger/notifications-modal-trigger';
import styles from './header-content-mobile.module.scss';
type HeaderContentMobileProps = {
  homeLabel?: string;
  isInsideSidebar?: boolean;
  isSecondaryTheme: boolean;
  languagesCmsContent?: LanguagesContent;
  navigationItems: NavigationItem[];
  profileDropdownCmsContent: HeaderAccountDropdownContent;
  profileDropdownSummarySlot: ReactNode;
};
export const HeaderContentMobile = t0 => {
  const $ = _c(27);
  const {
    homeLabel,
    isInsideSidebar,
    isSecondaryTheme,
    languagesCmsContent,
    navigationItems,
    profileDropdownCmsContent,
    profileDropdownSummarySlot
  } = t0;
  const {
    isAuthenticated,
    status
  } = useUserContext();
  const isSessionLoading = status === "loading";
  const {
    cmsContent: globalCmsContent
  } = useGlobalCmsContentContext();
  let t1;
  if ($[0] !== homeLabel) {
    t1 = homeLabel ? [{
      route: "/",
      title: homeLabel
    }] : [];
    $[0] = homeLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== navigationItems || $[3] !== t1) {
    t2 = [...t1, ...navigationItems];
    $[2] = navigationItems;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const mobileNavigationItems = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MdrtLogo className={styles["header-content__logo"]} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== globalCmsContent.goBackToHomePageLabel) {
    t4 = <div className={styles["header-content-mobile__logo-container"]}><Button aria-label={globalCmsContent.goBackToHomePageLabel} dataTestId="mobile-mdrt-logo-button" to={HOMEPAGE_PATH} variant={ButtonVariant.Plain}>{t3}</Button></div>;
    $[6] = globalCmsContent.goBackToHomePageLabel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isAuthenticated || $[9] !== isInsideSidebar || $[10] !== isSessionLoading) {
    t5 = isSessionLoading ? null : isAuthenticated && !isInsideSidebar && <div className={classnames(styles["header-content-mobile__notifications-modal-trigger-container"])}><NotificationsModalTrigger /></div>;
    $[8] = isAuthenticated;
    $[9] = isInsideSidebar;
    $[10] = isSessionLoading;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isAuthenticated || $[13] !== languagesCmsContent || $[14] !== mobileNavigationItems || $[15] !== profileDropdownCmsContent || $[16] !== profileDropdownSummarySlot) {
    t6 = close => <Navigation close={close} isAuthenticated={isAuthenticated} isMobile={true} languagesCmsContent={languagesCmsContent} navigationItems={mobileNavigationItems} profileDropdownCmsContent={profileDropdownCmsContent} profileSummarySlot={profileDropdownSummarySlot} />;
    $[12] = isAuthenticated;
    $[13] = languagesCmsContent;
    $[14] = mobileNavigationItems;
    $[15] = profileDropdownCmsContent;
    $[16] = profileDropdownSummarySlot;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== isSecondaryTheme || $[19] !== t6) {
    t7 = <ModalTrigger isSecondaryTheme={isSecondaryTheme}>{t6}</ModalTrigger>;
    $[18] = isSecondaryTheme;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t7) {
    t8 = <div>{t5}{t7}</div>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t4 || $[25] !== t8) {
    t9 = <div className={styles["header-content-mobile"]}>{t4}{t8}</div>;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};